export const SET_ATTRIBUTE_VALUE_START = 'SET_USER_START';
export const SET_ATTRIBUTE_VALUE_SUCCESS = 'SET_ATTRIBUTE_VALUE_START';
export const SET_ATTRIBUTE_VALUE_FAIL = 'SET_ATTRIBUTE_VALUE_FAIL';

export const UPDATE_ATTRIBUTE_VALUE_START = 'UPDATE_ATTRIBUTE_VALUE_START';
export const UPDATE_ATTRIBUTE_VALUE_SUCCESS = 'UPDATE_ATTRIBUTE_VALUE_SUCCESS';
export const UPDATE_ATTRIBUTE_VALUE_FAIL = 'UPDATE_ATTRIBUTE_VALUE_FAIL';

export const DELETE_ATTRIBUTE_VALUE_START = 'DELETE_ATTRIBUTE_VALUE_START';
export const DELETE_ATTRIBUTE_VALUE_SUCCESS = 'DELETE_ATTRIBUTE_VALUE_SUCCESS';
export const DELETE_ATTRIBUTE_VALUE_FAIL = 'DELETE_ATTRIBUTE_VALUE_FAIL';

export const RESET_ATTRIBUTE_VALUE_STORE = 'RESET_ATTRIBUTE_VALUE_STORE';

export const LOGOUT = 'LOGOUT';

export type AttributeValueActionTypes =
  | typeof SET_ATTRIBUTE_VALUE_START
  | typeof SET_ATTRIBUTE_VALUE_SUCCESS
  | typeof SET_ATTRIBUTE_VALUE_FAIL
  | typeof UPDATE_ATTRIBUTE_VALUE_START
  | typeof UPDATE_ATTRIBUTE_VALUE_SUCCESS
  | typeof UPDATE_ATTRIBUTE_VALUE_FAIL
  | typeof DELETE_ATTRIBUTE_VALUE_START
  | typeof DELETE_ATTRIBUTE_VALUE_SUCCESS
  | typeof DELETE_ATTRIBUTE_VALUE_FAIL
  | typeof RESET_ATTRIBUTE_VALUE_STORE
  | typeof LOGOUT;
